import {
  Menu,
  MenuItem,
  FormControlLabel,
  Divider,
  Grid2,
  IconButton,
  Tooltip,
  Checkbox,
  Collapse
} from "@mui/material";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import { ExpandMore, FilterAltOff } from "@mui/icons-material";
import { useLoading } from "../../../../components/Loading";
import { useEffect, useState } from "react";
import { useSnackbar } from "../../../../context/popup";
import { fetchData } from "../../../../services";
import DropDownConfig from "../../../Utils/DropDownConfig";


const FieldMappingFilterDialog = ({ anchorEl, open, onClose, filterData, setFilterData, onApply }) => {

    const {setCircleLoading} = useLoading();
    const {showSnackbar} = useSnackbar();

    //accordian states
    const [openActive, setOpenActive] = useState(false);
    const [openField, setOpenField] = useState(false);
    const [openInsurer, setOpenInsurer] = useState(false);
    const [openApi, setOpenApi] = useState(false);
    const [openTransform, setOpenTransform] = useState(false);
    const [openDirection, setOpenDirection] = useState(false);

    //options states
    const [fieldOptions, setFieldOptions] = useState([]);
    const [insurerOptions, setInsurerOptions] = useState([]);
    const [apiOptions, setApiOptions] = useState([]);
    const [transformOptions, setTransformOptions] = useState([]);
    const [dataDirectionOptions, setDataDirectionOptions] = useState([]);
    
    const sectionHeader = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "2px 6px",
        background: "#e9ecf5",
        borderRadius: "6px",
        cursor: "pointer",
        mb: 0.5,
    };

    const menuItemStyle = {
        borderRadius: "6px",
        my: 0.2,
        mx: 0.5,
        py: 0.3,
        "&:hover": { backgroundColor: "#dfe6ff" },
    };

    const labelStyle = {
        m: 0,
        "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
    };

    useEffect(() => {
        if(!open){
            return;
        }
        fetchFieldList();
    },[open]);

    const fetchFieldList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/api-engine/field-dictionary?dropdown=true`)

            if(response?.success){
                const formattedFields = response?.data?.items?.map((item) => ({
                    value: item?.id,
                    label: item?.label,
                })) || [];
                
                setFieldOptions(formattedFields)
            }
            else{
                //throw error
                showSnackbar("Error Fetching List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Data:', error);
            showSnackbar(error?.response?.data?.message ||"Error Fetching Field List", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const fetchInsurerRegistryList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/reference/api-engine/insurer-registry?dropdown=true`)

            if(response?.success){
                const formattedInsurerRegistry = response?.data?.insurer_registries?.map((item) => ({
                    value: item?.id,
                    label: item?.gInsurerName,
                })) || [];
                setInsurerOptions(formattedInsurerRegistry)
            }
            else{
                //throw error
                showSnackbar("Error Fetching List", "error")
            }
        } catch (error) {
            console.error('Error Fetching:', error);
            showSnackbar(error?.response?.data?.message || "Network Error", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const fetchApiCategoryList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/api-engine/key-value-store?dropdown=true&code=${DropDownConfig?.apiApiCategory}`)

            if(response?.success){
                const formattedApiCategories = response?.data?.items?.map((item) => ({
                    value: item?.id,
                    label: item?.keyName,
                })) || [];
                setApiOptions(formattedApiCategories)
            }
            else{
                //throw error
                showSnackbar("Error Fetching List", "error")
            }
        } catch (error) {
            console.error('Error Fetching data:', error);
            showSnackbar(error?.response?.data?.message || "Network Error", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const fetchTransformFnsList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/api-engine/transform-dictionary?dropdown=true`)

            if(response?.success){
                const formattedTransformFunctions = response?.data?.items?.map((item) => ({
                    value: item?.id,
                    label: item?.name,
                })) || [];
                setTransformOptions(formattedTransformFunctions)
            }
            else{
                //throw error
                showSnackbar("Error Fetching City List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Cities:', error);
            showSnackbar("Error Fetching City List", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const fetchDataDirectionList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/api-engine/key-value-store?dropdown=true&isActive=true&code=${DropDownConfig?.apiDataDirection}`)

            if(response?.success){
                const formattedDataDirections = response?.data?.items?.map((item) => ({
                    value: item?.id,
                    label: item?.keyName,
                })) || [];
                setDataDirectionOptions(formattedDataDirections)
            }
            else{
                //throw error
                showSnackbar("Error Fetching City List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Cities:', error);
            showSnackbar("Error Fetching City List", "error")
        }
        finally{
            setCircleLoading(false);
        }
    }

    const handleChange = ({ target: { name, value } }) => {
        setFilterData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const onClearFilters = () => {
        setFilterData({
            isActive: "",
            fieldId: "",
            iRegistryId: "",
            apiCategoryId: "",
            transformFnId: "",
            dataDirectionId: ""
        });
    };


  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{backgroundColor: "rgba(0, 0, 0, 0.3)",}}
      PaperProps={{
          elevation: 3,
          sx: {
            width: 250,
            padding: 1.5,
          },
      }}
    >
        <MaterialBox
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",             
        }}
        >
            {/* Title */}
            <MaterialTypography variant="body2" fontWeight="bold">
                Field Mapping Filter
            </MaterialTypography>

            {/* Clear Button */}
            <Tooltip title="Clear Filter" disableInteractive>
                <IconButton
                    size="small"
                    onClick={onClearFilters}
                    sx={{ color: "#ce0707ff" }}
                >
                    <FilterAltOff />
                </IconButton>
            </Tooltip>
        </MaterialBox>


      {/* Content */}
        <MaterialBox ml={1} mt={1} sx={{
        maxHeight: 300, 
        overflowY: "auto"}}>
            <Grid2 container>
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => setOpenActive(!openActive)}>
                        <MaterialTypography variant="body3" fontWeight="bold">
                            Active Status
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openActive ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openActive}>
                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: true },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === true} />}
                            label="Active"
                            sx={labelStyle}
                            />
                        </MenuItem>

                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: false },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === false} />}
                            label="Inactive"
                            sx={labelStyle}
                            />
                        </MenuItem>
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Field*/}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            setOpenField(!openField);
                        }}
                        >
                        <MaterialTypography variant="body3" fontWeight="bold">
                            Field
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openField ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openField}>
                        {fieldOptions?.map((item) => (
                            <MenuItem
                            key={item.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "fieldId", value: item.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.fieldId === item.value} />}
                                label={item.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Insurer Registry*/}
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openInsurer;
                            setOpenInsurer(nextState);

                            if (nextState && insurerOptions.length === 0) {
                                fetchInsurerRegistryList();
                            }
                        }}                        
                            >
                            <MaterialTypography variant="body3" fontWeight="bold">
                            Insurer Registry
                            </MaterialTypography>

                            <IconButton size="small">
                            <ExpandMore
                                sx={{
                                transform: openInsurer ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                                }}
                            />
                            </IconButton>
                        </MaterialBox>

                        <Collapse in={openInsurer}>
                            {insurerOptions?.map((state) => (
                            <MenuItem
                                key={state.value}
                                disableRipple
                                sx={menuItemStyle}
                                onClick={() =>
                                handleChange({
                                    target: { name: "iRegistryId", value: state.value },
                                })
                                }
                            >
                                <FormControlLabel
                                control={
                                    <Checkbox
                                    size="small"
                                    checked={filterData.iRegistryId === state.value}
                                    />
                                }
                                label={state.label}
                                sx={labelStyle}
                                />
                            </MenuItem>
                            ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* API Category */}
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openApi;
                            setOpenApi(nextState);

                            if (nextState && apiOptions.length === 0) {
                                fetchApiCategoryList();
                            }
                        }}>
                            <MaterialTypography variant="body3" fontWeight="bold">
                                API Category
                            </MaterialTypography>

                            <IconButton size="small">
                                <ExpandMore
                                sx={{
                                    transform: openApi ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "0.2s",
                                }}
                                />
                            </IconButton>
                        </MaterialBox>

                        <Collapse in={openApi}>
                        {apiOptions?.map((district) => (
                            <MenuItem
                            key={district.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "apiCategoryId", value: district.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={
                                <Checkbox
                                    size="small"
                                    checked={filterData.apiCategoryId === district.value}
                                />
                                }
                                label={district.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Transform Fn */}
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openTransform;
                            setOpenTransform(nextState);

                            if (nextState && transformOptions.length === 0) {
                                fetchTransformFnsList();
                            }
                        }}>
                            <MaterialTypography variant="body3" fontWeight="bold">
                                Transform Fn
                            </MaterialTypography>

                            <IconButton size="small">
                                <ExpandMore
                                sx={{
                                    transform: openTransform ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "0.2s",
                                }}
                                />
                            </IconButton>
                        </MaterialBox>

                        <Collapse in={openTransform}>
                        {transformOptions?.map((district) => (
                            <MenuItem
                            key={district.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "transformFnId", value: district.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={
                                <Checkbox
                                    size="small"
                                    checked={filterData.transformFnId === district.value}
                                />
                                }
                                label={district.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Data Direction*/}
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openDirection;
                            setOpenDirection(nextState);

                            if (nextState && dataDirectionOptions.length === 0) {
                                fetchDataDirectionList();
                            }
                        }}>
                            <MaterialTypography variant="body3" fontWeight="bold">
                                Data Direction
                            </MaterialTypography>

                            <IconButton size="small">
                                <ExpandMore
                                sx={{
                                    transform: openDirection ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "0.2s",
                                }}
                                />
                            </IconButton>
                        </MaterialBox>

                        <Collapse in={openDirection}>
                        {dataDirectionOptions?.map((district) => (
                            <MenuItem
                            key={district.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "dataDirectionId", value: district.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={
                                <Checkbox
                                    size="small"
                                    checked={filterData.dataDirectionId === district.value}
                                />
                                }
                                label={district.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
            </Grid2>
        </MaterialBox>

        <Divider />

        {/* Apply button */}
        <MenuItem
        onClick={() => onApply()}
        disableRipple
        sx={{
            padding: "6px 16px", 
            width: "fit-content",
            minWidth: "0px",
            mx: "auto",  
            borderRadius: "6px",
            backgroundColor: "#bcc7e9",
            color: "white",
            display: "flex",
            justifyContent: "center",
            transition: "0.2s ease",

            "&:hover": {
            backgroundColor: "#93a6e8",
            }
        }}
        >
        <MaterialTypography variant="button" fontWeight="bold">
            APPLY FILTER
        </MaterialTypography>
        </MenuItem>
    </Menu>
  );
};

export default FieldMappingFilterDialog;
